import { queryClient } from '@/queries';
import { customerQueries } from './customer.query';
import { customerQueryKeys } from './customer.keys';

export const invalidateCustomerListQueries = () => {
  return queryClient.invalidateQueries({ queryKey: customerQueryKeys.getList(), exact: false });
};

export const invalidateCustomerItemQueries = (customerId: string) => {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: customerQueries.item(customerId).queryKey }),
    queryClient.invalidateQueries({ queryKey: customerQueries.composedItem(customerId).queryKey }),
  ]);
};
